<footer id="footer">
    <a [href]="termsConditionsLink" target="_blank" id="terms">{{"SIGNUP.termsConditions" | translate}}</a>
    <a [href]="privacyPolicy" target="_blank">{{"SIGNUP.privacyPolicy" | translate}}</a>
</footer>